import { render, staticRenderFns } from "./Switcher.vue?vue&type=template&id=662337de&scoped=true"
import script from "./Switcher.vue?vue&type=script&lang=js"
export * from "./Switcher.vue?vue&type=script&lang=js"
import style0 from "./Switcher.vue?vue&type=style&index=0&id=662337de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662337de",
  null
  
)

export default component.exports